import type {ReactElement} from 'react';
import {PreviewAvatar} from '@Components/social-media/components/social-post-content-multiposting/components/preview-avatar/preview-avatar';
import {VerticalVideoAccountName} from '../vertical-video-account-name/vertical-video-account-name';
import {VerticalVideoActionIcons} from '../vertical-video-action-icons/vertical-video-action-icons';
import {VerticalVideoCaptionLine} from '../vertical-video-caption-line/vertical-video-caption-line';
import {VerticalVideoScrim} from '../vertical-video-scrim/vertical-video-scrim';
import type {FacebookOverlayProps} from './facebook-overlay.types';
import {FACEBOOK_REEL_ACTION_ICONS} from './facebook-overlay.types';
import styles from './facebook-overlay.module.scss';

export function FacebookOverlay({account, caption}: FacebookOverlayProps): ReactElement {
  const getScrim = (): ReactElement => {
    return <VerticalVideoScrim className={styles.facebookOverlayScrim} />;
  };

  const getCaptionBlock = (): ReactElement => {
    return (
      <div className={styles.facebookOverlayCaptionBlock}>
        {getIdentityRow()}
        <VerticalVideoCaptionLine caption={caption} moreClassName={styles.facebookOverlayCaptionMore} />
      </div>
    );
  };

  const getIdentityRow = (): ReactElement => {
    return (
      <div className={styles.facebookOverlayIdentity}>
        <PreviewAvatar account={account} className={styles.facebookOverlayAvatar} />
        {getNameBlock()}
      </div>
    );
  };

  const getNameBlock = (): ReactElement => {
    return (
      <div className={styles.facebookOverlayNameBlock}>
        <VerticalVideoAccountName accountName={account.name} />
        <span className={styles.facebookOverlayMetaSkeletonBar} aria-hidden="true" />
      </div>
    );
  };

  const getActionRail = (): ReactElement => {
    return (
      <div className={styles.facebookOverlayActionRail}>
        <VerticalVideoActionIcons iconNames={FACEBOOK_REEL_ACTION_ICONS} />
      </div>
    );
  };

  return (
    <>
      {getScrim()}
      {getCaptionBlock()}
      {getActionRail()}
    </>
  );
}
